export const WIDGET_RELATIVE_PATHS = {
    municipal48h: 'municipal48h',
    municipal8d: 'municipal8d',
    mapaPrediccio: 'mapaPrediccio',
    mapaRadar: 'mapaRadar',
    mapaAvisos: 'mapaAvisos',
};

export const WIDGET_NAMES = {
    municipal8d: 'municipal8d',
    municipal48h: 'municipal48h',
    prediccio: 'mapaPrediccio',
    radar: 'mapaRadar',
    avisos: 'mapaAvisos',
};

export const WIDGET_DIMENSIONS = {
    municipal8d: { width: '520', height: '218' },
    municipal48h: { width: '640', height: '350' },
    mapaRadar: { width: '396', height: '412' },
    mapaAvisos: { width: '297', height: '525' },
    mapaPrediccio: { width: '565', height: '388' },
    default: { width: '565', height: '388' },
};

// Padding & margin widgets
export const WIDGETS_PADDING = { padding: '0 10px' };
export const WIDGET_MARGIN_BOTTOM = 20;

export const WIDGET_TYPE = {
    corporate: 'corporate',
    monochrome: 'monochrome',
};

// Data Formats
export const SUFFIXES = {
    speed: {
        knots: 'knots',
        km: 'km/h',
    },
    temperature: {
        celsius: 'ºC',
        fahrenheit: 'ºF',
    },
};

// Config Defaults
export const DEFAULT_CONFIG = {
    alternativeTitle: '',
    city: 'Barcelona',
    widgetType: WIDGET_TYPE.corporate,
    color: '#2c3e50',
    language: 'ca',
    location: '080193',
    tempMaxColor: '#fd8d8a',
    tempMinColor: '#5eb9e2',
    tempFormat: SUFFIXES.temperature.celsius,
    windSpeedFormat: SUFFIXES.speed.km,
    // Municipal48h
    mainChart: 'estCel',
    secondaryChart: true,
    // Header Colors
    headerColor1: '#15468a',
    headerColor3: '#f9ca4e',
    headerColor2: '#00905f',
    // DayNav current color
    dayNavCurrentColor: '#fc706c',
};

export const MONOCHROME_COLORS = {
    tempMaxAlpha: 0.7,
    tempMinAlpha: 0.45,
};

// Colors in Mapa d'Avisos Widget
export const COLORS_AVISOS = {
    sensePerill: '#b1d330',
    perillModerat: '#ffd738',
    perillAlt: '#ed8426',
    perillMoltAlt: '#e00824',
    seaLayerSensePerill: '#fff',
    borderComarques: '#7f8c1c',
    borderSeaLayerSensePerill: '#b3b3b2',
};

export const PERILL_GRADES = {
    sense: 0,
    moderat: 1,
    alt: 2,
    moltAlt: 3,
};

// Used in radar to check if data is valid
export const MINUTES_FOR_NOT_SHOWING_TILES = 30;

// DataViz
export const GRAPH = {
    height: 121,
};

// Wind speed colors
export const WIND_SPEED_COLORS = {
    0: 'rgb(18,244,244)',
    5: 'rgb(8,159,252)',
    10: 'rgb(14,81,248)',
    20: 'rgb(16,13,112)',
    30: 'rgb(95,255,0)',
    40: 'rgb(1,206,63)',
    50: 'rgb(56,144,0)',
    60: 'rgb(32,95,1)',
    70: 'rgb(255,255,0)',
    80: 'rgb(255,235,0)',
};

// Tendencies correspondencies value <-> icon name
export const TENDENCIES_VALUES = {
    '1': 'Puja',
    '0': 'Mante',
    '-1': 'Baixa',
};

export const CATALUNYA_CENTER = {
    latitude: 41.7,
    longitude: 1.8,
};

export const MAX_BOUNDS = [[43, 3.6], [40.3, 0]];

export const meteorsAvisos = [
    { index: 0, nom: 'Intensitat de pluja' },
    { index: 1, nom: 'Acumulació de Pluja' },
    { index: 2, nom: 'Neu' },
    { index: 3, nom: 'Estat de la mar' },
    { index: 4, nom: 'Calor' },
    { index: 5, nom: 'Fred' },
    { index: 6, nom: 'Vent' },
];

// Other globals
export const NAUTICA_MILE_TO_KMH = 1.852;
export const METRES_TO_KMH = 3.6;
export const HORA_INICI_DIA = 7;
export const HORA_FI_DIA = 21;
export const ALTERNATIVE_TITLE_MAX_LENGTH = 50;



// WEBPACK FOOTER //
// ./src/utils/globals.js